const appsInTossHosts = new Set([
  "japangolmok.web.tossmini.com",
  "japangolmok.private-web.tossmini.com",
  "japangolmok.apps.tossmini.com",
  "japangolmok.private-apps.tossmini.com"
]);

export function apiUrl(path: `/api/${string}`, hostname = window.location.hostname): string {
  return appsInTossHosts.has(hostname) ? `https://japangolmok.com${path}` : path;
}

export function isAppsInTossHost(hostname = window.location.hostname): boolean {
  return appsInTossHosts.has(hostname);
}

export function isAppsInTossChannel(): boolean {
  return document.body.dataset.appChannel === "apps-in-toss" || isAppsInTossHost();
}
